import { styled } from '@mui/system';
import { Box, Avatar, Typography, Chip } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';

export const HeroWrapper = styled(Box)(({ theme }) => ({
  color: colors.primary,
  padding: '40px 20px 60px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    padding: '30px 20px 40px',
  },
}));

export const HeroContent = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
  padding: '0 24px',
  [theme.breakpoints.down('md')]: {
    padding: '0 16px',
  },
}));

export const ProfileRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 40,
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 24,
  },
}));

export const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 280,
  height: 280,
  borderRadius: 16,
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  backgroundColor: '#29405A',
  fontSize: 60,
  color: colors.whiteText,
  [theme.breakpoints.down('md')]: {
    width: 200,
    height: 200,
  },
}));

export const ProfileInfo = styled(Box)(({ theme }) => ({
  flex: 1,
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const ProfileName = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: 56,
  marginBottom: 8,
  [theme.breakpoints.down('lg')]: { fontSize: 48 },
  [theme.breakpoints.down('md')]: { fontSize: 32 },
}));

export const ProfileTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontSize: 20,
  marginBottom: 16,
  fontWeight: 500,
  [theme.breakpoints.down('md')]: { fontSize: 16 },
}));

export const ProfileHourlyRate = styled(ProfileTitle)(({ theme }) => ({
  color: '#29405A',
  justifySelf: 'flex-start',
  [theme.breakpoints.down('md')]: {
    justifySelf: 'center',
  },
}));

export const SpecialtiesLabel = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 14,
  fontWeight: 600,
  color: '#666',
  marginBottom: 8,
});

export const SpecialtiesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  marginBottom: 24,
  justifyContent: 'flex-start',
  [theme.breakpoints.down('md')]: { justifyContent: 'center' },
}));

export const SpecialtyChip = styled(Chip)({
  backgroundColor: '#F0EDE8',
  color: colors.primary,
  fontFamily: fontFamilies.quicksand,
  fontSize: 13,
});

export const ButtonConteiner = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  marginTop: 40,
}));
